<template>
    <div>
        <dx-grid
            :url="url"
            :columns="columns"
            :title="title"
            ref="grid"
            :actions="actions"
            :beforeSetupGrid="beforeSetupGrid"
            :onRowClicked="onRowClicked"
            navigationPath="onRowClicked"
            navigationField="onRowClicked"
        ></dx-grid>
        <v-dialog v-model="importStudentsDialog" max-width="400">
            <v-card class="pa-2">
                <div>
                    <v-card-title class="headline"
                        >Import Students</v-card-title
                    >
                    <v-layout row class="my-3">
                        <div class="font-weight-medium mr-2 mt-2 title">
                            Students ({{ students.length }})
                        </div>
                        <!-- <v-btn
                            class="mb-2 mt-0"
                            @click="clearNumbers"
                            small
                            color="success"
                            ><v-icon dark left>mdi-close-circle</v-icon>Clear
                            List</v-btn
                        > -->
                    </v-layout>
                    <v-layout row>
                        <div class="font-weight-regular" style="width: 35%">
                            Number
                        </div>
                        <div class="font-weight-regular" style="width: 35%">
                            Account ID
                        </div>
                        <div class="font-weight-regular" style="width: 35%">
                            Name
                        </div>
                        <div class="font-weight-regular" style="width: 35%">
                            Hebrew Name
                        </div>
                        <div class="font-weight-regular" style="width: 15%">
                            Phone Type
                        </div>
                        <div style="min-width: 10%"></div>
                        <!-- <v-btn
                                class="mt-0 pt-0"
                                style="width: 10%"
                                flat
                                icon
                                color="success"
                            >
                                <v-icon>mdi-close</v-icon>
                            </v-btn> -->
                    </v-layout>
                    <v-divider class="mb-2"></v-divider>
                    <div>
                        <div v-for="(student, index) in studentsToDisplay">
                            <v-layout row>
                                <!-- <v-checkbox
                                    class="mt-0 pt-0"
                                    style="max-width: 40px;"
                                    v-model="number.selected"
                                    color="success"
                                    hide-details
                                ></v-checkbox> -->
                                <div style="width: 35%">
                                    {{ student.childFirst }}
                                </div>
                                <div style="width: 35%">
                                    {{ student.childLast }}
                                </div>
                                <div style="width: 35%">
                                    {{ student.birthday | date }}
                                </div>
                                <div style="width: 35%">
                                    {{ student.address1 }}
                                </div>
                                <div style="width: 15%">
                                    {{ student.address2 }}
                                </div>
                                <div style="width: 15%">
                                    {{ student.familyPrimaryPhone }}
                                </div>
                                <div style="width: 15%">
                                    {{ student.father }}
                                </div>
                                <div style="width: 15%">
                                    {{ student.mother }}
                                </div>
                            </v-layout>
                            <v-divider
                                class="mb-2"
                                v-if="index + 1 < students.length"
                            ></v-divider>
                        </div>
                    </div>
                    <!-- <v-layout justify-center class="mt-3 mb-1">
                            <v-pagination
                                v-model="pagination.page"
                                :length="pages"
                                :total-visible="5"
                                v-on:input="setPagianation"
                            ></v-pagination>
                        </v-layout> -->

                    <v-card-actions>
                        <v-spacer></v-spacer>
                        <v-btn
                            color="default"
                            @click="importStudentsDialog = false"
                            >Cancel</v-btn
                        >
                        <v-btn dark color="success" @click="importStudents">
                            Import
                        </v-btn>
                    </v-card-actions>
                </div>
            </v-card>
        </v-dialog>
        <v-dialog v-model="matchDialog" max-width="400">
            <v-card class="pa-2">
                <v-card-title class="headline px-2"
                    >Match To Account</v-card-title
                >

                <div class="px-2">
                    <v-layout row class="mb-2">
                        <div class="font-weight-medium width-150">
                            Child First
                        </div>
                        <div>{{ clickedRow.childFirst }}</div>
                    </v-layout>
                    <v-layout row class="mb-2">
                        <div class="font-weight-medium width-150">
                            Child Last
                        </div>
                        <div>{{ clickedRow.childLast }}</div>
                    </v-layout>
                    <v-layout row class="mb-2">
                        <div class="font-weight-medium width-150">Father</div>
                        <div>{{ clickedRow.father }}</div>
                    </v-layout>
                    <v-layout row class="mb-2">
                        <div class="font-weight-medium width-150">Address</div>
                        <div>
                            {{
                                clickedRow.address1 + " " + clickedRow.address2
                            }}
                        </div>
                    </v-layout>
                    <v-layout row class="mb-2">
                        <div class="font-weight-medium width-150">
                            Primary Phone
                        </div>
                        <div>{{ clickedRow.familyPrimaryPhone }}</div>
                    </v-layout>
                    <v-divider class="mt-2"></v-divider>

                    <div v-if="matchedUtaAccounts.length">
                        <div class="my-2 font-weight-medium text-success">
                            Matched UTA Accounts
                        </div>
                        <div
                            v-for="account in matchedUtaAccounts"
                            style="cursor: pointer; border-radius: 4px"
                            class="pa-2"
                            v-bind:class="{
                                'hs-selected-match': isSelectedUtaAccount(
                                    account,
                                ),
                                'hs-match': !isSelectedUtaAccount(account),
                            }"
                            @click="selectAccount(account)"
                        >
                            <v-layout row justify-space-between>
                                <div>
                                    <div
                                        class="font-weight-medium caption pa-1 px-2 cyan"
                                        style="color: #fff; width: fit-content;"
                                    >
                                        {{ account.accountID }}
                                    </div>
                                    <div class="pt-2">{{ account.name }}</div>
                                </div>
                                <div>
                                    <div class="pb-2">
                                        {{ account.address1 }}
                                    </div>
                                    <div>{{ account.homePhone }}</div>
                                </div></v-layout
                            >
                        </div>
                    </div>
                    <div
                        v-if="
                            !matchedUtaAccounts.length &&
                                matchedAnslAccounts.length
                        "
                    >
                        <div class="my-2 font-weight-medium text-success">
                            Matched ANSL Accounts
                        </div>
                        <div
                            v-for="account in matchedAnslAccounts"
                            style="cursor: pointer; border-radius: 4px"
                            class="pa-2"
                            v-bind:class="{
                                'hs-selected-match': isSelectedAnslAccount(
                                    account,
                                ),
                                'hs-match': !isSelectedAnslAccount(account),
                            }"
                            @click="selectAccount(account)"
                        >
                            <v-layout row justify-space-between>
                                <div>
                                    <div
                                        class="font-weight-medium caption pa-1 px-2 deep-orange lighten-1"
                                        style="color: #fff; width: fit-content;"
                                    >
                                        {{ account.personID }}
                                    </div>
                                    <div class="pt-2">{{ account.name }}</div>
                                </div>
                                <div>
                                    <div class="pb-2">
                                        {{ account.address1 }}
                                    </div>
                                    <!-- <div>{{ account.homePhone }}</div> -->
                                </div></v-layout
                            >
                        </div>
                    </div>
                    <div
                        class="font-weight-medium title text-center mt-2 text-danger"
                        v-if="
                            !matchedUtaAccounts.length &&
                                !matchedAnslAccounts.length
                        "
                    >
                        No Accounts Matched
                    </div>
                    <v-btn outline color="success" small @click="searchAccounts"
                        >Search Accounts</v-btn
                    >
                </div>
                <v-card-actions class="mr-2 mt-3 pb-2">
                    <v-spacer></v-spacer>
                    <v-btn dark color="default" @click="matchDialog = false"
                        >Cancel</v-btn
                    >
                    <v-btn
                        dark
                        color="warning"
                        v-if="allowUnmatch()"
                        :loading="processing"
                        @click="match({ unmatch: true })"
                    >
                        UnMatch
                    </v-btn>
                    <v-btn
                        v-if="allowMatch()"
                        :loading="processing"
                        dark
                        color="success"
                        @click="match"
                    >
                        Match
                    </v-btn>
                </v-card-actions>
            </v-card>
        </v-dialog>
        <v-dialog v-model="searchAccountsDialog" max-width="1600">
            <v-card>
                <data-grid
                    class="accounts-search"
                    url="donorsSearch"
                    name="hs-accounts-search"
                    :columns="accountsColumns"
                    navigationPath="onSearchAccountsRowClicked"
                    navigationField="onSearchAccountsRowClicked"
                    title="Accounts"
                    v-bind:hideActions="true"
                    :onRowClicked="onSearchAccountsRowClicked"
                ></data-grid>
            </v-card>
        </v-dialog>
    </div>
</template>

<script>
export default {
    data: () => ({
        title: "HS Imported Students",

        actions: [],
        userBranch: "",
        url: "",
        regID: "",

        importStudentsDialog: false,
        students: [],
        studentsToDisplay: [],

        matchDialog: false,
        clickedRow: {},
        matchedUtaAccounts: [],
        matchedAnslAccounts: [],
        selectedAccount: {},
        processing: false,
        searchAccountsDialog: false,

        regID: "",

        pagination: {
            totalCount: 0,
            rowsPerPage: 13,
            page: 1,
        },

        columns: [
            {
                label: "Child First",
                field: "childFirst",
                format: "",
                visible: true,
                filterType: "",
                filterValues: [],
                filterValue: null,
                selectedFilterOperation: null,
            },
            {
                label: "Child Last",
                field: "childLast",
                sortOrder: "asc",
                sortIndex: 0,
                format: "",
                visible: true,
                filterType: "",
                filterValues: [],
                filterValue: null,
                selectedFilterOperation: null,
            },
            {
                label: "Father",
                field: "father",
                format: "",
                visible: true,
                filterType: "",
                filterValues: [],
                filterValue: null,
                selectedFilterOperation: null,
            },
            {
                label: "Mother",
                field: "mother",
                format: "",
                visible: true,
                filterType: "",
                filterValues: [],
                filterValue: null,
                selectedFilterOperation: null,
            },
            {
                field: "utaAccountID",
                label: "UTA Account ID",
                link: "Account View",
                format: "",
                template: "link-cell-template",
                visible: true,
                filterType: "",
                filterValues: [],
                filterValue: null,
                selectedFilterOperation: null,
            },
            {
                field: "donorID",
                label: "Ansl ID",
                link: "DinnerAccountView",
                format: "",
                template: "link-cell-template",
                visible: true,
                filterType: "",
                filterValues: [],
                filterValue: null,
                selectedFilterOperation: null,
            },
            {
                label: "Screening Date",
                field: "screeningDate",
                visible: true,
                filterValues: [],
                filterValue: null,
                selectedFilterOperation: null,
            },
            {
                label: "Birthday",
                field: "birthday",
                visible: true,
                type: "date",
                format: "MM/dd/yyyy",
                filterValues: [],
                filterValue: null,
                selectedFilterOperation: null,
            },
            {
                label: "Address1",
                field: "address1",
                format: "",
                visible: true,
                filterType: "",
                filterValues: [],
                filterValue: null,
                selectedFilterOperation: null,
            },
            {
                label: "Address2",
                field: "address2",
                format: "",
                visible: true,
                filterType: "",
                filterValues: [],
                filterValue: null,
                selectedFilterOperation: null,
            },
            {
                label: "Primary Phone",
                field: "familyPrimaryPhone",
                format: "",
                visible: true,
                filterType: "",
                filterValues: [],
                filterValue: null,
                selectedFilterOperation: null,
            },
            {
                label: "Child Plus Family ID",
                field: "familyID",
                format: "",
                visible: true,
                filterType: "",
                filterValues: [],
                filterValue: null,
                selectedFilterOperation: null,
            },
            {
                label: "Is Matched",
                field: "isMatched",
                type: "boolean",
                format: "",
                visible: true,
                filterType: "",
                filterValues: [],
                filterValue: null,
                selectedFilterOperation: null,
            },
            {
                label: "Is UTA Matched",
                field: "isutaMatched",
                type: "boolean",
                format: "",
                visible: true,
                filterType: "",
                filterValues: [],
                filterValue: null,
                selectedFilterOperation: null,
            },
            {
                label: "Is Ansl Matched",
                field: "isAnslMatched",
                type: "boolean",
                format: "",
                visible: true,
                filterType: "",
                filterValues: [],
                filterValue: null,
                selectedFilterOperation: null,
            },
        ],

        accountsColumns: [
            {
                sortable: false,
                label: "Person ID",
                field: "personID",
                width: "115px",
                hidden: false,
                filterOptions: {
                    enabled: true,
                    placeholder: "Search Person ID..",
                },
            },
            {
                sortable: true,
                label: "Name",
                field: "ename",
                hidden: false,
                width: "200px",
                filterOptions: {
                    enabled: true,
                    placeholder: "Search Name..",
                },
            },
            {
                sortable: false,
                label: "Hebrew Name",
                width: "250px",
                field: "yname",
                hidden: false,
                filterOptions: {
                    enabled: true,
                    placeholder: "Search Hebrew Name..",
                },
            },
            {
                sortable: false,
                label: "Address",
                field: "address",
                width: "200px",
                hidden: false,
                filterOptions: {
                    enabled: true,
                    placeholder: "Search Address..",
                },
            },
            {
                sortable: false,
                label: "Address3",
                field: "address3",
                width: "200px",
                hidden: false,
                filterOptions: {
                    enabled: true,
                    placeholder: "Search Address..",
                },
            },
            {
                sortable: false,
                label: "Phone",
                field: "phone",
                width: "150px",
                hidden: false,
                // searchValue: (value) => {
                //     return value.replace(/(\d{3})(\d{3})(\d{4})/, "$1-$2-$3");
                // },
                filterOptions: {
                    enabled: true,
                    placeholder: "Search Home Phone..",
                },
            },
            {
                sortable: false,
                label: "UTA ID",
                field: "parentId",
                width: "115px",
                hidden: false,
                filterOptions: {
                    enabled: true,
                    placeholder: "Search UTA ID..",
                },
            },
            {
                sortable: false,
                label: "Father",
                field: "father",
                hidden: false,
                filterOptions: {
                    enabled: true,
                },
            },
            {
                sortable: false,
                label: "Shver",
                field: "fatherInLaw",
                hidden: false,
                filterOptions: {
                    enabled: true,
                },
            },
        ],
    }),
    async created() {
        this.columns.find(
            (c) => c.field == "familyID",
        ).showLink = this.showLink;
        this.columns.find((c) => c.field == "donorID").showLink = this.showLink;

        this.actions.push({
            text: "Auto Match To Account",
            action: this.autoMatchToAccount,
            name: "autoMatchToAccount",
        });
    },
    beforeDestroy() {},
    methods: {
        async beforeSetupGrid() {
            this.userBranch = this.$store.state.authentication.branch;

            // this.actions.push({
            //     text: "Register Student",
            //     action: this.register,
            // });

            // this.actions.push({
            //     text: "Import Students",
            //     action: this.openImportStudents,
            // });

            await this.loadRegID();

            const terms = await this.getTerms();

            this.actions.push({
                text: "Select Term",
                type: "select",
                values: terms,
                value: this.regID,
                onSelected: this.onTermSelected,
            });

            this.url = "hsStudents?onlyHs=&onlyVoucher=&regID=" + this.regID;
        },
        async loadRegID() {
            this.regID = await this.$http.get("api/hsStudents/getRegID");
        },
        async getTerms() {
            return await this.$http.get("api/hsStudents/getRegTerms");
        },
        onTermSelected(value) {
            this.regID = value;

            let url = "hsStudents?";

            this.url = url += "onlyHs=&onlyVoucher=&regID=" + this.regID;

            this.$refs.grid.reloadDataSource(this.url);
        },
        searchAccounts() {
            this.searchAccountsDialog = true;
        },
        showLink() {
            return (
                !this.$store.state.authentication.branch ||
                this.$store.state.authentication.branch == "null"
            );
        },
        register() {
            this.$router.push({
                name: "RegisterHS",
            });
        },
        async onRowClicked(row) {
            this.clickedRow = row;
            this.selectedAccount = {};

            // if (!this.clickedRow.familyPrimaryPhone) {
            //     return this.$notify({
            //         text: "Can't match without a Phone Number",
            //         group: "notification",
            //         type: "error",
            //     });
            // }

            const response = await this.$http.get(
                "api/hsStudents/getMatchedAccounts?number=" +
                    this.clickedRow.familyPrimaryPhone,
            );

            this.matchedUtaAccounts = response.accounts;

            if (this.matchedUtaAccounts.length == 1) {
                this.selectedAccount = this.matchedUtaAccounts[0];
            }

            this.matchedAnslAccounts = response.dinnerAccounts;

            if (
                !this.selectedAccount.accountID &&
                this.matchedAnslAccounts.length == 1
            ) {
                this.selectedAccount = this.matchedAnslAccounts[0];
            }

            this.matchDialog = true;
        },
        isSelectedUtaAccount(account) {
            return this.selectedAccount.accountID == account.accountID;
        },
        isSelectedAnslAccount(account) {
            return this.selectedAccount.personID == account.personID;
        },
        selectAccount(account) {
            this.selectedAccount = account;
        },
        allowUnmatch() {
            return this.clickedRow.isMatched;
        },
        allowMatch() {
            return !this.clickedRow.isMatched;
        },
        getAnslAccount() {
            if (this.selectedAccount.personID)
                return this.selectedAccount.personID;

            const anslAccount = this.matchedAnslAccounts.find(
                (a) => a.parentId == this.selectedAccount.accountID,
            );

            return anslAccount ? anslAccount.personID : null;
        },
        getUtaAccount() {
            return this.selectedAccount.accountID
                ? this.selectedAccount.accountID
                : this.selectedAccount.parentId;
        },
        async match({ unmatch = false }) {
            if (
                !unmatch &&
                !this.selectedAccount.personID &&
                !this.selectedAccount.accountID
            ) {
                return this.$notify({
                    text: "No Account Selected",
                    group: "notification",
                    type: "error",
                });
            }

            try {
                this.processing = true;

                await this.$http.post("api/hsStudents/MatchToAccount", {
                    user: this.$store.state.authentication.user,
                    utaAccountID: unmatch ? null : this.getUtaAccount(),
                    anslID: unmatch ? null : this.getAnslAccount(),
                    student: this.clickedRow,
                });

                this.processing = false;
                this.matchDialog = false;

                this.$notify({
                    text: "Changes Saved",
                    group: "notification",
                    type: "success",
                });

                this.$refs.grid.reloadGrid();
            } catch (e) {
                this.processing = false;
            }
        },
        onSearchAccountsRowClicked(account) {
            this.searchAccountsDialog = false;

            account.nameH = account.yname;
            account.name = account.ename;
            account.address1 = account.address;

            this.matchedAnslAccounts = [account];
            this.selectedAccount = account;

            //this.onAccountSelected();
        },
        openImportStudents() {
            this.importStudentsDialog = true;
        },
        async importStudents() {},
        async autoMatchToAccount() {
            try {
                const response = await this.$http.post(
                    "api/hsStudents/accountAutoMatch?user=" +
                        this.$store.state.authentication.user +
                        "&regID=" +
                        this.regID,
                );

                this.$notify({
                    text: response.matched + " students matched",
                    group: "notification",
                    type: "success",
                });

                this.$refs.grid.reloadGrid();
            } catch (e) {}
        },
    },
};
</script>
<style>
[v-cloak] {
    display: none;
}
.v-btn__content {
    color: unset;
}
.hs-selected-match {
    border: 2px solid red;
}
.hs-match {
    border: 1px solid #4caf50;
}
.accounts-search.container {
    padding-top: 0px;
}
</style>
